import React from "react";
import { useGetEcoleDashboard } from "@/lib/backoffice-hooks";
import { useCurrentUser } from "@/lib/auth";
import AnneeSelector from "@/components/AnneeSelector";
import BackofficeShell from "@/components/layout/BackofficeShell";
import {
  LayoutDashboard,
  Tags,
  Users,
  Contact,
  Receipt,
  PenSquare,
  Banknote,
  Inbox,
  ShieldCheck,
  School,
  Landmark,
} from "lucide-react";

// `manage: true` = écriture de paramétrage (motifs, demandes) réservée aux
// rôles économe/admin. Le backend refuse déjà ces écritures à `caisse`
// (MotifResource @RolesAllowed admin/econome → 403) ; on masque aussi le menu
// pour ne pas exposer des actions vouées à l'échec au rôle caisse.
const navItems = [
  { href: "/ecole", label: "Tableau de bord", icon: LayoutDashboard },
  { href: "/ecole/classes", label: "Classes", icon: School, manage: true },
  { href: "/ecole/motifs", label: "Motifs de paiement", icon: Tags, manage: true },
  { href: "/ecole/eleves", label: "Élèves", icon: Users },
  { href: "/ecole/parents", label: "Parents", icon: Contact, manage: true },
  { href: "/ecole/demandes", label: "Demandes", icon: Inbox, manage: true },
  { href: "/ecole/paiements", label: "Paiements", icon: Receipt },
  { href: "/ecole/paiements-hors-systeme", label: "Hors système", icon: Banknote },
  { href: "/ecole/saisie", label: "Saisie hors-ligne", icon: PenSquare },
  { href: "/ecole/compte-reversement", label: "Compte de reversement", icon: Landmark, manage: true },
];

const MANAGE_ROLES = new Set(["econome", "econome_etab", "admin", "super_admin"]);

export default function EcoleShell({ children }: { children: React.ReactNode }) {
  const { data: dashboard } = useGetEcoleDashboard();
  const { user } = useCurrentUser();
  const canManage = (user?.roles ?? []).some((r) =>
    MANAGE_ROLES.has(r.toLowerCase()),
  );
  const items = navItems.filter((it) => !it.manage || canManage);
  return (
    <BackofficeShell
      title="CATHO SCHOOL · Espace École"
      icon={ShieldCheck}
      navItems={items}
      selector={<AnneeSelector />}
      subtitle={
        dashboard?.ecoleDenomination ? (
          <span
            className="hidden lg:inline-block text-white/70 border-l border-white/20 pl-3 truncate"
            data-testid="header-ecole-name"
          >
            {dashboard.ecoleDenomination}
          </span>
        ) : undefined
      }
    >
      {children}
    </BackofficeShell>
  );
}
